import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SignUp from '../views/SignUp.vue'
import LoginView from '../views/LoginView.vue'
import FindPassword from '../views/FindPassword.vue'
import ChangePassword from '../views/ChangePassword.vue'
import PlantTree from '../views/PlantTree.vue'
import ExamPaper1 from '../views/ExamPaper1.vue'
import ExamPaper2 from '../views/ExamPaper2.vue'
import ExamPaper3 from '../views/ExamPaper3.vue'
import PairUp from '../views/PairUp.vue'
import GameByUnity from '../views/GameByUnity.vue'
import ShopView from '../views/ShopView.vue'
import ShopForVisitor from '../views/ShopForVisitor.vue'
import RedeemForm from '../views/RedeemForm.vue'
import RedeemFormForCertification from '../views/RedeemFormForCertification.vue'
import CertificationView from '../views/CertificationView.vue'
// import store from '@/store/index.js'

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: SignUp,
  },
  {
    path: '/login-view',
    name: 'LoginView',
    component: LoginView,
  },
  {
    path: '/find-password',
    name: 'FindPassword',
    component: FindPassword,
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
  },
  {
    path: '/plant-tree',
    name: 'PlantTree',
    component: PlantTree,
  },
  {
    path: '/exam-paper-1',
    name: 'ExamPaper1',
    component: ExamPaper1,
  },
  {
    path: '/exam-paper-2',
    name: 'ExamPaper2',
    component: ExamPaper2,
  },
  {
    path: '/exam-paper-3',
    name: 'ExamPaper3',
    component: ExamPaper3,
  },
  {
    path: '/pair-up',
    name: 'PairUp',
    component: PairUp,
  },
  {
    path: '/game-by-unity',
    name: 'GameByUnity',
    component: GameByUnity,
  },
  {
    path: '/shop-view',
    name: 'ShopView',
    component: ShopView,
  },
  {
    path: '/shop-for-visitor',
    name: 'ShopForVisitor',
    component: ShopForVisitor,
  },
  {
    path: '/redeem-form',
    name: 'RedeemForm',
    component: RedeemForm,
  },
  {
    path: '/redeem-form-for-certification',
    name: 'RedeemFormForCertification',
    component: RedeemFormForCertification,
  },
  {
    path: '/certification-view',
    name: 'CertificationView',
    component: CertificationView,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// router.beforeEach((to, from) => {
//   // 生产环境下强制每次都从首页进入
//   if (process.env.NODE_ENV === 'production' && !from.name && to.name !== 'HomeView' && !to.query['no-redirect']) {
//     return '/'
//   }
// })

export default router
